import React, { useRef, useEffect } from 'react';
import { onHandleClasses } from './../../utils/onClickHandlerAll';
import ProjectCardContent from './../ProjectCardContent';
import ProjectCardMedia from './../ProjectCardMedia';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import './ListProject.css';

const itemProject = (data, onHandleClasses, uploadScroll) => {
  const { title, index, newProject, premierProject, image, urlPage, urlGit } = data;

  const classes = (
    `${newProject && "btn-card-new"}
      ${premierProject && "btn-premier"}`
  )

  return (
    <Card className="card" elevation={7} key={title}>
      <Button
        className={`btn-card ${classes}`} 
        onClick={() => {
            uploadScroll()
            onHandleClasses(index)
          }}
        >
        <ProjectCardMedia
          image={image}
        />
        <ProjectCardContent
          title={title}
          urlPage={urlPage}
          urlGit={urlGit}
          onHandleClasses={onHandleClasses} />
      </Button>
    </Card>
  );
}

const ListProject = ({ data, long }) => {
  //se esta importando onHandleClasses 👆 

  function uploadScroll(){
    localStorage.setItem("projectsScrollY", window.scrollY)
  } 

  return (
    <Grid container className="container-card" justifyContent="center" alignItems="center">
      <Grid item container className='display-flex align-items-center justify-content-space-evenly' xs={11} justifyContent="space-evenly" alignItems="center">
        {
          data.map((dataElement, i) => {
            if (Number.parseInt(long) !== -1 && i >= Number.parseInt(long)) {
              return
            }

            return itemProject(dataElement, onHandleClasses, uploadScroll)
          })
        }
      </Grid>
    </Grid>
  )
}

export default React.memo(ListProject);